import BN from 'bignumber.js'

function apply (Vue) {
    Vue.filter('roundup', function (value, scale) {
        let s = (scale !== null && scale !== undefined) ? scale : 8;

        BN.set({ROUNDING_MODE:BN.ROUND_UP})

        return (new BN(value)).toFixed(s);
    });
}

export default {
    apply: apply,
};
